<template>
  <div class="container">
	  <!-- 我的订单  v-if="activeindex == 5"-->
	 <!-- 优惠券 -->
	 
	 <!-- 我的考试记录 -->
	 <div class="content">
	 	<el-table :data="examHistory"  style="width: 100%">
	 	      <el-table-column
	 	        prop="paperName"
	 	        label="考试名称"
	 	        >
	 	      </el-table-column>
	 	      <el-table-column
	 	        prop="userName"
	 	        label="姓名">
	 	      </el-table-column>
	 		  <el-table-column
	 		    prop="fullScore"
	 		    label="满分">
	 		  </el-table-column>
	 		  <el-table-column
	 		    prop="getScore"
	 		    label="得分">
	 		  </el-table-column>
	 	      <el-table-column
	 	        prop="createTime"
	 	        label="提交时间">
	 	      </el-table-column>
			  <el-table-column  label="成绩"  aligh="center" width="100">
			  	<template slot-scope="scope">
			  		<el-button icon="el-icon-warning" style="color: firebrick;" @click="joinExam(scope.row)" type="text" size="small" v-if="scope.row.getScore<scope.row.paper.passScore">未通过</el-button>
			  		<el-button icon="el-icon-finished" type="text" size="small" v-if="scope.row.getScore>=scope.row.paper.passScore" style="color: blue;">考试合格</el-button>
			  	</template>
			  </el-table-column>
	      </el-table>
	 	<!-- <div class="couse" v-if="examHistory.length <= 0 " style="display: flex">
	 		<div style="margin: auto;top: 70px;">您没有任何学习记录！</div>
	 	</div> -->
	 </div>
	 
  </div>
</template>

<script>
	import {queryExamHistoryList} from "@/api/exam";
	export default {
	  data() {
	    return {
		    examHistory:[],
			currentYear:null,
			queryParams: {
				pageNum: 1,
				pageSize: 6,
				year: localStorage.getItem('year')
			},
	    }
	  },
	  created() {
		this.currentYear = localStorage.getItem('year');
	  	this.queryExamHistoryList();
	  },
	  methods: {
		queryExamHistoryList(){
			this.queryParams.year = localStorage.getItem('year');
			if(this.queryParams.year == null || this.queryParams.year ==''){
				alert("清先设置培训年度！");
				return;
			}
		  	queryExamHistoryList(this.queryParams).then(response => {
		  	  this.examHistory = response.rows;
		  	})
		},
	    handleChange(view) {
	      this.$nextTick(() => {
	        // 可在此处添加切换逻辑
	      })
	    }
	  }
	}
</script>

<style scoped>
	.certificate {
		border-top: 1px dashed #dcdcdc;
		padding-top: 27px;
		display: flex;
		flex-wrap: wrap;
	
		.cerlist {
			border-radius: 5px 5px 5px 5px;
			background: #f7f8fa;
			padding: 17px 17px 17px 24px;
			margin-right: 15px;
			margin-bottom: 28px;
	
			&:nth-child(3n) {
				margin-right: 0;
			}
	
			.title {
				font-size: 18px;
				font-weight: 600;
				color: #333333;
				margin-bottom: 10px;
			}
	
			.time {
				font-size: 16px;
				color: #777777;
	
				img:nth-child(1) {
					margin-left: 80px;
					margin-right: 12px;
				}
			}
		}
	}
	.component-wrapper {
	  margin-top: 20px;
	  border: 1px solid #ebeef5;
	  padding: 20px;
	  border-radius: 4px;
	}
</style>